import React, {Component} from "react"
import IBox from './IBox'

class IBoxRow extends Component {
  render() {

    const className = this.props.className || ''

    return (

      <div className={`row`}>
        <div className={`col-lg-12 ${className}`}>
          <IBox title={this.props.title}>
            {this.props.children}
          </IBox>
        </div>
      </div>

    )
  }
}

export default IBoxRow



// WEBPACK FOOTER //
// ./src/components/IBoxRow.js